import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export function useVenueName() {
  const location = useLocation();

  const [name, setName] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const venueFromUrl = location.pathname.split("/")[1];

    if (venueFromUrl) {
      // URL ma priorytet
      setName(venueFromUrl);
      setLoading(false);
      return;
    }

    // Fallback do Firestore
    const loadDefaultName = async () => {
      try {
        const appConfigRef = doc(db, "config", "app");
        const snap = await getDoc(appConfigRef);

        if (snap.exists()) {
          const data = snap.data();
          if (data?.name) {
            setName(data.name);
          }
        }
      } catch (err) {
        console.error("Błąd ładowania domyślnej nazwy venue:", err);
      } finally {
        setLoading(false);
      }
    };

    loadDefaultName();
  }, [location.pathname]);

  return { name, loading };
}
